export const CARE_COLLECTIONS_PATH = 'v1/care-collections';
export const CARE_TOPICS_PATH = 'v1/care-topics';
